import { Text as MantineText } from "@mantine/core";

import { TextProps } from "./types";
import { useTextStyles } from "./useTextStyles";

export function Text({
  sizeVariant = "base",
  as = "p",
  children,
  className = "",
  dataTestId = "",
  ...mantineTextProps
}: TextProps) {
  const { classes } = useTextStyles(sizeVariant);

  return (
    <MantineText
      component={as}
      data-testid={dataTestId}
      className={`${classes.text} ${className}`}
      {...mantineTextProps}
    >
      {children}
    </MantineText>
  );
}
